import { render, staticRenderFns } from "./TitleLogo.vue?vue&type=template&id=3489c246"
import script from "./TitleLogo.vue?vue&type=script&lang=js"
export * from "./TitleLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports